__turbopack_context__.v({
  "close": "KB0lPq_close",
  "content": "KB0lPq_content",
  "footer": "KB0lPq_footer",
  "header": "KB0lPq_header",
  "panel": "KB0lPq_panel",
  "panel--l": "KB0lPq_panel--l",
  "panel--m": "KB0lPq_panel--m",
  "panel--plain": "KB0lPq_panel--plain",
  "panel--s": "KB0lPq_panel--s",
  "panel-in": "KB0lPq_panel-in",
  "panel-out": "KB0lPq_panel-out",
  "root": "KB0lPq_root",
  "scrim": "KB0lPq_scrim",
  "scrim-in": "KB0lPq_scrim-in",
  "scrim-out": "KB0lPq_scrim-out",
  "title": "KB0lPq_title",
  "title--l": "KB0lPq_title--l",
});
